module.exports = __webpack_public_path__ + "static/media/studio_rotating_telehandler_mrt_2260_manitou_003.a19dadeb.png";